module.exports = __webpack_public_path__ + "static/img/navigate_next.20349172.svg";